module.exports = __webpack_public_path__ + "img/down3.c4e639f3.png";